import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
const firebaseConfig = {
  apiKey: "AIzaSyAKDTdm1fsQfL09J3QCh7k0QFayna8zo7A",
  authDomain: "to-go-packing.firebaseapp.com",
  projectId: "to-go-packing",
  storageBucket: "to-go-packing.firebasestorage.app",
  messagingSenderId: "1080336214882",
  appId: "1:1080336214882:web:54b19a69307f11ba6d9a3b",
  measurementId: "G-Y9E4TEEHQC"
};

const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
export { app, db, auth, googleProvider };


